export enum PopoverType {
  CART = 'cart',
  LOGIN = 'login',
  SIDEBAR = 'sidebar',
  NOTIFICATION = 'notification',
}

export interface PopoverState {
  activePopover: PopoverType | null;
  openPopover: (popoverType: PopoverType) => void;
  openSidebarPopover: () => void;
  closePopover: () => void;
}
